import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  createCheckout: function(plan) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/billing/checkout", {
      plan: plan
    });
  },
  // Sellable plans and prices, sourced from the Stripe dashboard rather than
  // hardcoded here. Shape: { plans: [{ slug, name, amount_pence, currency,
  // interval, users_label, banding_label }], launch_fee: { name, amount_pence }
  // | null }. 503 means the catalogue is unavailable; callers keep a fallback.
  catalogue: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/public/purchase/catalogue");
  }
};
